export function formatDate(dateString: string): string {
  const hasTime = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(dateString);
  const date = hasTime ? new Date(dateString) : new Date(`${dateString}T00:00:00-08:00`);

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day} ${year}`;
}
